import moment from "moment";
import lodash from "lodash";
import { REDUX_SET_VALUE, REDUX_SET_VALUE_RECURSIVE } from "./actions";

const authLocalStorage = localStorage.getItem("user");
const defaultAuth = authLocalStorage && authLocalStorage.trim() !== "" ? JSON.parse(authLocalStorage) : null;

const initialStore = {
    initDate: moment().format(),
    auth: defaultAuth && defaultAuth.email && defaultAuth.email.trim() !== "" && defaultAuth._id ? defaultAuth : null,
    sidebarMobileOpen: false,
};

const appReducer = (state = initialStore, action) => {
    switch (action.type) {
        case REDUX_SET_VALUE:
            return {
                ...state,
                [action.payload.setting]: action.payload.value,
            };
        case REDUX_SET_VALUE_RECURSIVE:
            return lodash.set({ ...state }, action.payload.path, action.payload.value);
        case "REDUX_TOGGLE_SIDEBAR":
            return {
                ...state,
                sidebarMobileOpen: !state.sidebarMobileOpen,
            };
        default:
            return state;
    }
};
export default appReducer;
